import { render, staticRenderFns } from "./PanelSlider.vue?vue&type=template&id=3529f7ec&"
import script from "./PanelSlider.vue?vue&type=script&lang=js&"
export * from "./PanelSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports